import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { AuditarService } from '@pages/auditar/services/auditar.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import { Inject } from '@angular/core';


@Component({
  selector: 'app-auditar',
  templateUrl: './auditar.component.html',
  styleUrls: ['./auditar.component.css']
})
export class AuditarComponent implements OnInit {
  public columns: string[] = [
    'codigo',
    'mensaje',
    'rango1',
    'rango2',
    'valorStr',
    'variable', 
  ]; 
  public allData: number = 0;
  public loading: boolean = true;

  constructor(
    private _auditarService: AuditarService,
    @Inject(MAT_DIALOG_DATA) public clavePerfilOp: any
    ) { } 

  dataSource = new MatTableDataSource();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  
  @ViewChild(MatSort) sort: MatSort;
  
  ngOnInit(): void {
    this.loadAuditTable();
    console.log(this.clavePerfilOp.clavePerfilOp)
  }

  loadAuditTable(){
    this._auditarService.read(this.clavePerfilOp.clavePerfilOp).subscribe((res) => {  
      this.dataSource.data = res.data;
      if (res.data) this.allData = res.data.length;
      if (this.allData >= 0) this.loading = false;
    });
  }

}
